import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=08d4de74&"
import script from "./Catalog.vue?vue&type=script&lang=ts&"
export * from "./Catalog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports